export default __webpack_public_path__ + "static/Entenda0076-b23ddfe6561ee9d8e4a59703a8ba7fa8.jpg";